import { motion } from "framer-motion";
import { assetUrl } from "@/lib/api";

export default function StorySection({ wedding }) {
  return (
    <section className="py-20 sm:py-28 px-6 sm:px-12 max-w-5xl mx-auto" data-testid="story-section">
      <div className="grid sm:grid-cols-2 gap-10 sm:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="eyebrow mb-4">La nostra storia</p>
          <h2 className="font-wed text-3xl sm:text-4xl mb-6">Come tutto è cominciato</h2>
          <div className="text-neutral-600 leading-relaxed space-y-4">
            {(wedding.story_text || "").split("\n\n").map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </motion.div>
        {wedding.story_photo_url && (
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="order-first sm:order-last"
          >
            <img
              src={assetUrl(wedding.story_photo_url)}
              alt="La nostra storia"
              className="rounded-3xl w-full aspect-[4/5] object-cover shadow-xl"
            />
          </motion.div>
        )}
      </div>
    </section>
  );
}
